import TppExportModal from './TppExportModal';
import TppImportExcelModal from './TppImportExcelModal';
import TppPoolSettingsModal from './TppPoolSettingsModal';
import type {
  TppExportSubmitPayload,
  TppPoolSettingsSeed,
  TppPoolSettingsSubmitPayload,
} from './tppDataModalTypes';

type TppDataModalsProps = {
  closeLabel: string;
  poolKey: string;
  poolSettingsSeed: TppPoolSettingsSeed | undefined;
  exportOpen: boolean;
  onExportHide: () => void;
  exportPending: boolean;
  exportError: unknown;
  onExportSubmit: (payload: TppExportSubmitPayload) => void;
  importOpen: boolean;
  onImportHide: () => void;
  importPending: boolean;
  importError: unknown;
  onImportSubmit: (file: File) => void;
  onImportErrorReset: () => void;
  poolSettingsOpen: boolean;
  onPoolSettingsHide: () => void;
  poolSettingsPending: boolean;
  poolSettingsError: unknown;
  onPoolSettingsSubmit: (payload: TppPoolSettingsSubmitPayload) => void;
};

/** Excel 出力・インポート・プール設定（フォーム状態は内部保持） */
export default function TppDataModals({
  closeLabel,
  poolKey,
  poolSettingsSeed,
  exportOpen,
  onExportHide,
  exportPending,
  exportError,
  onExportSubmit,
  importOpen,
  onImportHide,
  importPending,
  importError,
  onImportSubmit,
  onImportErrorReset,
  poolSettingsOpen,
  onPoolSettingsHide,
  poolSettingsPending,
  poolSettingsError,
  onPoolSettingsSubmit,
}: TppDataModalsProps) {
  return (
    <>
      <TppExportModal
        closeLabel={closeLabel}
        show={exportOpen}
        onHide={onExportHide}
        pending={exportPending}
        error={exportError}
        onSubmit={onExportSubmit}
      />
      <TppImportExcelModal
        closeLabel={closeLabel}
        poolKey={poolKey}
        show={importOpen}
        onHide={onImportHide}
        pending={importPending}
        error={importError}
        onSubmit={onImportSubmit}
        onErrorReset={onImportErrorReset}
      />
      <TppPoolSettingsModal
        closeLabel={closeLabel}
        seed={poolSettingsSeed}
        show={poolSettingsOpen}
        onHide={onPoolSettingsHide}
        pending={poolSettingsPending}
        error={poolSettingsError}
        onSubmit={onPoolSettingsSubmit}
      />
    </>
  );
}
